<template>
  <div class="col-sm-12 routa-dark">
    <h1 class="title orange">{{ $t('menu.what') }}</h1>
    <p class="text-center">{{ $t('what.description') }}</p>
    <!-- Target markets -->
    <b-row class="reference-container" align-h="center">
    <div class="col-sm-5 p-2">
        <div class="reference">
          <!--
          <img class="img-fluid w-100" src=""/>
          -->
          <span class="sub-title orange">{{ $t('what.title1')}}</span>
          <span class="article-text">{{ $t('what.description1')}}</span>
          <span class="article-text">{{ $t('what.description1_2')}}</span>
        </div>
      </div>
      <div class="col-sm-5 p-2">
        <div class="reference">
          <!--
          <img class="img-fluid w-100" src=""/>
          -->
          <span class="sub-title orange">{{ $t('what.title2')}}</span>
          <span class="article-text">{{ $t('what.description2')}}</span>
        </div>
      </div>
    </b-row>
    <b-row class="reference-container mb-3" align-h="center">
      <div class="col-sm-5 p-2">
        <div class="reference">
          <!--
          <img class="img-fluid w-100" src=""/>
          -->
          <span class="sub-title orange">{{ $t('what.title3')}}</span>
          <span class="article-text">{{ $t('what.description3')}}</span>
        </div>
      </div>
      <div class="col-sm-5 p-2">
        <div class="reference">
          <!--
          <img class="img-fluid w-100" src=""/>
          -->
          <span class="sub-title orange">{{ $t('what.title4')}}</span>
          <span class="article-text">{{ $t('what.description4')}}</span>
        </div>
      </div>
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'What',
}
</script>

